import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { getVerbalColors } from 'helpers'
import { Icon, Typography } from 'foundations-library/components'
import { IconNameType } from 'foundations-library/types'

const useStyles = makeStyles((theme) => {
    const { colors } = theme['foundations-library']
    const verbalColors = getVerbalColors(colors)

    return {
        root: {
            display: 'flex',
            maxWidth: '200px',
            height: '29px',
            padding: '5px 10px 0px 10px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
            borderRadius: '10px',
            background: ({ color }: { color?: string }) => color || verbalColors['primary-50']
        },
        couponContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
        }
    }
})

/**
 *
 */
const Coupon = ({ title, icon, color }: { title: string, icon?: IconNameType, color?: string }) => {
    const classes = useStyles({ color })

    return (
        <div className={`${classes.root} coupon`}>
            <div className={classes.couponContainer}>
                <Icon name={icon || 'tag'} size={'small'} color='neutral-900' />
                <Typography variant='body2heavy' color='neutral-900' style={{ whiteSpace: 'nowrap' }}>{title}</Typography>
            </div>
        </div>
    )
}

export default Coupon
